<template>
  <div aria-hidden="true" :style="{ 'width': `${size}px`, 'height': `${size}px` }" class="AVATAR">
    <img
        v-if="hasImageURL && !isImageUnavailable"
        v-show="isImageLoaded"
        class="IMAGE"
        :src="image || fallbackImage"
        @load="onImageLoaded"
        @error="onBrokenImage"
    />
    <div
        v-if="!hasImageURL || isImageUnavailable || !isImageLoaded"
        :style="initialsStyle"
        class="INITIALS"
        :class="{
          'x-pulse': hasImageURL && (!isImageLoaded || !isImageUnavailable)
        }"
    >{{ initials }}</div>
  </div>
</template>
<script>
import { depot, gray50 } from './colors';

export default {
  name: 'avatar',
  props: {
    size: {
      type: Number,
      default: 50,
    },
    image: {
      type: String,
      default: '',
    },
    fallbackImage: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    id: {
      type: Number,
      default: 0,
    },
    inverse: {
      type: Boolean, // Set avatar color instead of background-color (background-color white)
      default: false,
    },
    iconColor: {
      type: [String, Object],
      default () {
        return { background: 'white', color: gray50 };
      },
    },
  },
  data () {
    return {
      hasImageURL: !!this.image || !!this.fallbackImage,
      isImageLoaded: false,
      isImageUnavailable: false,
    };
  },
  computed: {
    initials () {
      const [firstInitial = ''] = this.name;
      const [lastInitial = ''] = this.name.split(' ').pop();

      return firstInitial + lastInitial;
    },
    initialsStyle () {
      const color = typeof this.iconColor === 'string'
        ? this.iconColor
        : this.iconColor.color || gray50;

      return {
        color: this.inverse ? color : 'white',
        'background-color': this.inverse ? 'white' : depot,
        'font-size': `${this.size / 2}px`,
        'line-height': `${this.size}px`,
      };
    },
  },
  methods: {
    onImageLoaded () {
      this.isImageLoaded = true;
    },
    onBrokenImage (e) {
      if (this.fallbackImage && !e.target.src.includes(this.fallbackImage)) {
        e.target.src = this.fallbackImage;
      } else {
        this.isImageUnavailable = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.AVATAR {
  position: relative;
  display: flex;
  user-select: none;
  border-radius: 50%;
  overflow: hidden;
}

.IMAGE,
.INITIALS {
  width: 100%;
  height: 100%;
}

.IMAGE {
  object-fit: cover;
}

.INITIALS {
  position: absolute;
  text-align: center;
}
</style>
